import { EntityTypes } from './enums';

export interface ChampionApplication {
  entityType: EntityTypes.championApplication;
  applicationId: string;
  firstName: string;
  lastName: string;
  applicationEmail: string;
  title: string;
  bio: string;
  linkedIn: string;
  created: number;
    lastUpdated: number;
}

export interface ChampionApplicationInput {
    firstName: string;
    lastName: string;
    applicationEmail: string;
    title: string;
    bio: string;
    linkedIn: string;
}